<h2 mat-dialog-title>{{ editMode ? ('EDITJOB' | translate) : ('ADDJOB' | translate) }}</h2>

<mat-dialog-content>
    <form [formGroup]="Form">

        <mat-form-field appearance="fill" class="form-field">
            <mat-label>{{ 'COMPANY' | translate }}</mat-label>
            <input matInput formControlName="company" placeholder="{{ 'ENTERCOMPANYNAME' | translate }}" />
            <mat-error *ngIf="Form.get('company')?.hasError('required')">
              {{ 'REQUIREDFIELD' | translate }}
            </mat-error>
        </mat-form-field>
      
        <mat-form-field appearance="fill" class="form-field">
            <mat-label>{{ 'POSITION' | translate }}</mat-label>
            <input matInput formControlName="position" placeholder="{{ 'ENTERPOSITIONNAME' | translate }}" />
            <mat-error *ngIf="Form.get('position')?.hasError('required')">
              {{ 'REQUIREDFIELD' | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'STARTDATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="startdate" id="startdate" formControlName="startdate" placeholder="{{ 'ENTERSTARTDATE' | translate }}" />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="startdate"></mat-datepicker-toggle>
          <mat-datepicker #startdate></mat-datepicker>
          <mat-error *ngIf="Form.get('startdate')?.hasError('required')">
            {{ 'REQUIREDFIELD' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'ENDDATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="enddate" id="enddate" formControlName="enddate" placeholder="{{ 'ENTERENDDATE' | translate }}" />
          <mat-hint>DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matIconSuffix [for]="enddate"></mat-datepicker-toggle>
          <mat-datepicker #enddate></mat-datepicker>
          <mat-error *ngIf="Form.get('enddate')?.hasError('required')">
            {{ 'REQUIREDFIELD' | translate }}
          </mat-error>
        </mat-form-field>

    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-raised-button color="primary" [disabled]="Form.invalid" (click)="onSubmit()">{{ editMode ? ('EDIT' | translate) : ('ADD' | translate) }}</button>
</mat-dialog-actions>
